<template>
  <div style="overflow-x:hidden;background: #7AC7FC" :style="viewStyle">
    <div class="header-bar">
      <v-img :src="images.new_logo" class="header-logo"></v-img>
      <v-img :src="images.title" class="header-title"></v-img>
      <v-img :src="images.school" class="header-school"></v-img>
      <v-img :src="images.icon_L1" class="header-icon" style="top: 300px; left: 4%"></v-img>
      <v-img :src="images.icon_L2" class="header-icon" style="top: 600px; left: 12%"></v-img>
      <v-img :src="images.icon_L3" class="header-icon" style="top: 900px; left: 0%"></v-img>
      <v-img :src="images.icon_L4" class="header-icon" style="top: 1200px; left: 8%"></v-img>
      <v-img :src="images.icon_R1" class="header-icon" style="top: 300px; right: 4%"></v-img>
      <v-img :src="images.icon_R2" class="header-icon" style="top: 600px; right: 0%"></v-img>
      <v-img :src="images.icon_R3" class="header-icon" style="top: 900px; right: 12%"></v-img>
      <v-img :src="images.icon_R4" class="header-icon" style="top: 1200px; right: 5%"></v-img>
    </div>
    <div class="ma-0">
      <v-row class="mx-0 mt-6" style="width:100%; height:100%; align-items: center;" justify="center">
        <v-col class="col-12 col-sm-10 col-md-8" style="display: flex; justify-content: center"> 
          <div id="box2" class="px-2 py-12">
            <v-row class="ma-0" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-8">
                <v-row class="ma-0 DarkBlue" justify="center" style="align-items: center">
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                  <h1 class="title-text">招生服務入口</h1>
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                </v-row>
                <v-row class="mx-0 my-2 pa-2" justify="center" style="background:#E8E8E8; color:#000">
                  <h4 class="remind">無論是新生、家長或駐點老師，您都能在此找到對應的服務與資訊</h4>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="portal-row" justify="center">
              <v-btn
                v-for="(btn, i) in portalBtns"
                :key="i"
                class="portal-btn"
                outlined
                color="#FFF"
                :style="{ background: btn.bg }"
                @click="openLink(btn.info)"
              >
                <v-col class="pa-0 pl-3 img-col">
                  <v-img :src="btn.img" contain />
                </v-col>
                <v-col class="pa-0 text-col">
                  <h2 class="px-1 title-text3">{{ btn.line1 }}</h2>
                  <h2 class="px-1 title-text3">{{ btn.line2 }}</h2>
                </v-col> 
              </v-btn>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0" justify="center">
        <h4 class="mb-4 pt14" style="color:#FFF">Copyright©2025 東泰高級中學</h4>
      </v-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Portal',
  components: {},
  mounted(){
    this.calculateWindows()
    window.onresize = () => {
      this.calculateWindows()
    }
  },
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/logo.png'),
      title: require('@/assets/image/title.png'),
      school: require('@/assets/image/school.png'),
      icon_L1: require('@/assets/image/icon_L1.png'),
      icon_L2: require('@/assets/image/icon_L2.png'),
      icon_L3: require('@/assets/image/icon_L3.png'),
      icon_L4: require('@/assets/image/icon_L4.png'),
      icon_R1: require('@/assets/image/icon_R1.png'),
      icon_R2: require('@/assets/image/icon_R2.png'),
      icon_R3: require('@/assets/image/icon_R3.png'),
      icon_R4: require('@/assets/image/icon_R4.png'),
    },
    portalBtns:[
      { img: require('@/assets/image/btn-1.png'), bg: '#EE5F36', line1: '新生', line2: '報名專區', info: 'path'},
      { img: require('@/assets/image/btn-2.png'), bg: '#FFA800', line1: '招生', line2: '查詢專區', info: 'https://app.ttsh.hcc.edu.tw/ttsh/admin' },
      { img: require('@/assets/image/btn-3.png'), bg: '#002C61', line1: '駐點', line2: '老師專區', info: 'https://sites.google.com/school.ttsh.hcc.edu.tw/admissions/%E9%A6%96%E9%A0%81' }
    ],
  }),
  watch:{},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    openLink(info){
      if(info == 'path'){
        this.redirectPath('/registration')
      }else{
        window.open(info, "_blank");
      }
    },
  }
}
</script>

<style scoped>
.header-bar {
  position: relative;
  width: 100%;
  height: 210px;
}

.header-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  max-width: 280px;
  width: 30%;
  min-width: 120px;
}

.header-title {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 760px;
  width: 50%;
  min-width: 120px;
}

.header-school {
  position: absolute;
  top: 0px;
  right: 0px;
  max-width: 360px;
  width: 28%;
  min-width: 120px;
}

.header-icon {
  position: absolute;
}

.portal-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 2rem 0;
  min-height:300px
}

/* 統一按鈕樣式 */
.portal-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: transform 0.2s ease;

  margin: 1px;
  width: 30%;
  max-width: 250px;
  height:100px !important;
  border-radius: 10px;
  /* justify-content: center; */
}

/* hover 效果（可選） */
.portal-btn:hover {
  transform: translateY(-3px);
}

.img-col {
  max-width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title-text3 {
  color: #fff;
  margin: 0;
}

/* 響應式：小於 759px 改為垂直排列 */
@media (max-width: 759px) {
  .portal-row {
    flex-direction: column;
    align-items: center;
  }

  .portal-btn {
    width: 90%;
  }
}

@media (max-width: 960px) {
  .header-logo {
    max-width: 340px;
    width: 50%;
  }
  .header-title {
    top: 60px;
    width: 160%;
  }
  .header-school {
    display: none
  }
}
</style>